import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import {
    Container, createMuiTheme, Toolbar, Typography, CssBaseline, Snackbar, FormControl, InputLabel, Select, TextField, Button, Divider, Checkbox, Backdrop, CircularProgress
    , Dialog, DialogTitle, DialogContent, DialogActions, Grid, AppBar
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import MuiAlert from '@material-ui/lab/Alert';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Autocomplete from '@material-ui/lab/Autocomplete';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Theme } from '../contexts/themeContext';
import { User } from '../contexts/userContext.js';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import ConfirmDialog from '../common/confirmDialog';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    },
    dialog: {
        position: 'absolute',
        left: 15,
        top: 200,
        width: 400,
        height: 500
    }
}));

export default function Dashboard(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { userDetail, getCurrentUserDetails } = useContext(User);
    const [reports, setReports] = useState([]);
    const [hirNodes, setHirNodes] = useState([]);
    const [siteNodes, setSiteNodes] = useState([]);
    const [nodes, setNodes] = useState([]);
    const [startDate, setStartDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite));
    const [endDate, setEndDate] = useState(ConvertToCurrentTimeZone(new Date(), "L", 24, defaultSite));
    const [reportId, setReportId] = useState(0);
    const [lastCheckedLevel, setLastCheckedLevel] = useState(0);
    const [hirNode, setHirNode] = useState([]);
    const [selectedNode, setSelectedNode] = useState({});
    const [selectedSite, setSelectedSite] = useState("");
    const [selectedSites, setSelectedSites] = useState("");
    const [selected, setSelected] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [exagoWebURL, setExagoWebURL] = useState("");
    const [apiKey, setApiKey] = useState("");
    const [apiInitialized, setApiInitialized] = React.useState(false);
    const [loadCount, setLoadCount] = useState(0);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    let interval = null;
    let exagoInitinterval = null;

    const confirmClose = () => {
        setConfirmOpen(false);
    };

    const treeViewOpen = () => {
        setHirNode(null);
        setOpen(true);
    };

    const treeViewClose = () => {
        setOpen(false);
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const updateLoadCount = (add) => {
        if (add)
            setLoadCount(loadCount => loadCount + 1);
        else
            setLoadCount(loadCount => loadCount - 1);
    };

    const loadExagoAPI = () => {
        let iframe = document.getElementById("iFrameExago");
        iframe.height = window.innerHeight - 270;
        updateLoadCount(true);

        if (iframe.contentWindow.initExagoAPI !== undefined) {
            iframe.contentWindow.initExagoAPI(exagoWebURL, apiKey);
            interval = setInterval(function () {
                exagoInitComplete();
            }, 2000);
        }
        else {
            exagoInitinterval = setInterval(function () {
                checkExagoAPIState();
            }, 2000);
        }
    };

    const checkExagoAPIState = () => {
        let iframe = document.getElementById("iFrameExago");

        if (iframe.contentWindow.initExagoAPI !== undefined) {
            clearInterval(exagoInitinterval);
            iframe.contentWindow.initExagoAPI(exagoWebURL, apiKey);
            interval = setInterval(function () {
                exagoInitComplete();
            }, 2000);
        }
    };

    const exagoInitComplete = () => {
        let iframe = document.getElementById("iFrameExago");

        if (iframe.contentWindow.apiInitialized) {
            clearInterval(interval);
            setApiInitialized(true);
            updateLoadCount(false);
        }
    };

    const reloadDashboard = () => {
        let reportName = "";
        let index = reports.findIndex(item => item.RptReportId === reportId);

        if (index !== -1)
            reportName = reports[index].ReportName;

        if ((apiInitialized) && reportName !== "") {
            let costCenters = "";
            if (selectedSite !== "") {
                if (selectedSites.length === 0) {
                    costCenters = defaultSite.houseCode[0];
                }
                else {
                    for (index = 0; index < selectedSites.length; index++) {
                        if (costCenters === "")
                            costCenters = selectedSites[index].Brief;
                        else
                            costCenters += "|" + selectedSites[index].Brief;
                    }
                }
            }

            let iframe = document.getElementById("iFrameExago");
            iframe.contentWindow.loadDashboard(reportName, userDetail.AppUseUserName, costCenters, startDate, endDate);
        }
    };
    
    const getSystemVariables = () => {
        updateLoadCount(true);
        HttpService.post("/SystemVariable/GetVariableValue", { key: "ExagoWebURL" })
            .then((result) => {
                if (result) {
                    setExagoWebURL(result.VariableValue);
                }
                updateLoadCount(false);               
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };

    const getExagoSession = () => {
        updateLoadCount(true);
        HttpService.post("/Dashboard/GetExagoSession")
            .then((result) => {
                if (result.error) {
                    setErrorMessage(result.message);
                    setOpenError(true);
                }
                else {
                    setApiKey(result.data.ApiKey);
                }
                updateLoadCount(false);
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };

    const getReports = () => {
        updateLoadCount(true);
        HttpService.post("/Dashboard/GetReports")
            .then((result) => {
                setReports(result.data);
                setReportId(result.data[0].RptReportId);
                updateLoadCount(false);
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };
    
    const getNodes = () => {
        updateLoadCount(true);
        HttpService.post("/Dashboard/GetNodes")
            .then((result) => {
                let data = result.data;
                let nodesTemp = [];
                let levelNodes = [];
                // Add ENT level and its child nodes
                nodesTemp = data.filter(item => item.Level === 37);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "ENT", 37)
                }

                // Add SVP level and its child nodes
                nodesTemp = data.filter(item => item.Level === 2);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "SVP", 2);
                }

                // Add DVP level and its child nodes
                nodesTemp = data.filter(item => item.Level === 34);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "DVP", 34);
                }

                // Add RVP level and its child nodes
                nodesTemp = data.filter(item => item.Level === 3);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "RVP", 3);
                }

                // Add SRM level and its child nodes
                nodesTemp = data.filter(item => item.Level === 36);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "SRM", 36);
                }

                // Add RM level and its child nodes
                nodesTemp = data.filter(item => item.Level === 4);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "RM", 4);
                }

                // Add AM level and its child nodes
                nodesTemp = data.filter(item => item.Level === 41);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "AM", 41);
                }

                // Add Unit level and its child nodes
                nodesTemp = data.filter(item => item.Level === 7);
                if (nodesTemp.length > 0) {
                    levelNodes = addLevelNodes(levelNodes, nodesTemp, "Site Name", 7);
                }
                setHirNodes(data);
                setNodes(levelNodes);
                setSiteNodes(nodesTemp);
                updateLoadCount(false);
            },
                (error) => {
                    console.log(error);
                    updateLoadCount(false);
                });
    };

    const addLevelNodes = (levelNodes, nodes, level, nodeId) => {
        let data = levelNodes;
        data.push({ id: nodeId, parentId: -1, level: nodeId, name: level, checked: false, fullPath: "\\crothall", childNodes: [] });
        let levelIndex = data.length - 1;

        for (let index = 0; index < nodes.length; index++) {
            data[levelIndex].childNodes.push({ id: nodes[index].Id, parentId: nodeId, level: nodes[index].Level, name: nodes[index].Title, fullPath: nodes[index].FullPath, checked: false });
        }

        return data;
    };

    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };

    const hirNodeChanged = (node) => {
        if (node !== null) {
            let parentNode = getParentNode(node.Level);
            let currentNode = { id: node.Id, parentId: parentNode.Id, level: node.Level, name: node.Title, fullPath: node.FullPath };

            setHirNode(node);
            nodeSelected(true, currentNode);
        }
    };

    const getParentNode = (level) => {
        let nodeIndex = 0;

        for (let index = 0; index < nodes.length; index++) {
            if (nodes[index].level === level) {
                nodeIndex = index;
                break;
            }
        }

        return nodes[nodeIndex];
    };

    const parentCheckChange = (node) => {
        let selectedNodes = [];

        selectedNodes.push(node.id);
        for (let index in node.childNodes) {
            selectedNodes.push(node.childNodes[index].id);
            if (node.childNodes[index].childNodes) {
                parentCheckChange(node.childNodes[index]);
            }
        }

        return selectedNodes;
    };

    const chidCheckChange = (node) => {
        let selectedNodes = [];

        for (let index in node.childNodes) {
            if (!selected.includes(node.childNodes[index].id)) {
                selectedNodes.push(node.childNodes[index].id);
                if (node.childNodes[index].childNodes) {
                    chidCheckChange(node.childNodes[index]);
                }
            }
        }

        return selectedNodes;
    };

    const parentNodeCheck = (parentNode) => {
        var checkedNodesCount = 1;

        for (let index = 0; index < parentNode.childNodes.length; index++) {
            if (selected.includes(parentNode.childNodes[index].id)) {
                checkedNodesCount++;
            }
        }

        return (parentNode.childNodes.length === checkedNodesCount);
    };

    const selectNode = () => {
        let checkedNodes = [];
        let childNodesToToggle = [];
        let expandedNodes = [];
        let parentNode = null;

        setConfirmOpen(false);
        parentNode = getParentNode(lastCheckedLevel);
        childNodesToToggle = parentCheckChange(parentNode);
        checkedNodes = selected.filter(value => !childNodesToToggle.includes(value));
        checkedNodes.push(selectedNode.id);
        if (selectedNode.parentId === -1) {
            childNodesToToggle = chidCheckChange(selectedNode);
            for (let index = 0; index < childNodesToToggle.length; index++) {
                checkedNodes.push(childNodesToToggle[index]);
            }
        }
        setLastCheckedLevel(selectedNode.level);
        setSelected(checkedNodes);
        parentNode = getParentNode(selectedNode.level);
        expandedNodes.push(parentNode.id.toString());
        setExpanded(expandedNodes);
    };

    const nodeSelected = (checked, node) => {
        let checkedNodes = [];
        let childNodesToToggle = [];
        let parentNode = null;

        if (lastCheckedLevel !== -1 && lastCheckedLevel !== node.level && selected.length > 0) {
            setSelectedNode(node);
            setConfirmOpen(true);
        }
        else {
            childNodesToToggle.push(node.id);
            checkedNodes = checked ? [...selected, ...childNodesToToggle] : selected.filter(value => !childNodesToToggle.includes(value));

            if (node.parentId !== -1) {
                parentNode = getParentNode(node.level);
                if (checked) {
                    if (parentNodeCheck(parentNode)) {
                        checkedNodes.push(parentNode.id);
                    }
                }
                else {
                    checkedNodes = checkedNodes.filter(value => value !== parentNode.id);
                }
            }
            else {
                childNodesToToggle = chidCheckChange(node);
                if (checked) {
                    for (let index = 0; index < childNodesToToggle.length; index++) {
                        checkedNodes.push(childNodesToToggle[index]);
                    }
                }
                else {
                    childNodesToToggle = parentCheckChange(node);
                    checkedNodes = checkedNodes.filter(value => !childNodesToToggle.includes(value));
                }
            }

            setLastCheckedLevel(node.level);
            setSelected(checkedNodes);
        }
    };

    const updateSitesList = () => {
        let hirNodesAll = [];
        let hirNodesSingle = [];
        let selectedSitesTemp = [];

        setOpen(false);

        for (let index = 0; index < selected.length; index++) {
            hirNodesSingle = hirNodes.filter(item => item.Id === selected[index]);
            hirNodesAll.push(...hirNodesSingle);
        }

        for (let index = 0; index < hirNodesAll.length; index++) {
            let filteredSites = siteNodes.filter(item => item.FullPath.indexOf(hirNodesAll[index].FullPath) >= 0);
            selectedSitesTemp.push(...filteredSites);
        }

        setSelectedSites(selectedSitesTemp);
        setSelectedSite(selectedSitesTemp.length + " Sites selected");
        reloadDashboard();
    };

    const renderTree = nodesToRender => {
        const elements = [];

        nodesToRender.forEach((item, index) => {
            const { id, name, childNodes } = item;
            const label = (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                        color="primary"
                        id={`checkNode-${id}`}
                        className={classes.globalFilterCheckbox}
                        checked={selected.includes(id)}
                        onChange={(event, checked) => nodeSelected(checked, item)}
                        onClick={e => (e.stopPropagation())}
                    />
                    <Typography variant="caption">{name}</Typography>
                </div>
            );
            elements.push(
                childNodes && childNodes.length > 0 ? (
                    <TreeItem key={id} nodeId={id.toString()} label={label}>
                        {renderTree(childNodes)}
                    </TreeItem>
                ) : (
                        <TreeItem key={id} nodeId={id.toString()} label={label} />
                    ),
            );
        });

        return elements;
    };

    useEffect(() => {
        getSystemVariables();
        getExagoSession();
        getReports();
        getNodes();
        if (userDetail.length === 0)
            getCurrentUserDetails();
        setSelectedSite(defaultSite.name);
        let startOfWeek = moment().startOf('isoweek').toDate();
        let endOfWeek = moment().endOf('week').toDate();
        setStartDate(ConvertToCurrentTimeZone(startOfWeek, "L", null, defaultSite));
        setEndDate(ConvertToCurrentTimeZone(endOfWeek, "L", null, defaultSite));
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (exagoWebURL !== "" && apiKey !== "")
            loadExagoAPI();
        // eslint-disable-next-line 
    }, [exagoWebURL, apiKey]);

    useEffect(() => {
        reloadDashboard();
        // eslint-disable-next-line 
    }, [apiInitialized, reportId, startDate, endDate]);

    useEffect(() => {
        if (loadCount > 0)
            setBackDrop(true);
        else
            setBackDrop(false);
    }, [loadCount]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="dashboardBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeErrorSnackbar} severity="error">
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            <Link to="/"><KeyboardBackspaceIcon /></Link>
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" className={classes.title}>&nbsp;PE Dashboard</Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end">
                                <SmallMenu modified={false} />
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <div className={classes.root} autoComplete="off">
                                <Grid container direction="row" spacing={1}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <FormControl variant="outlined" size="small" className={classes.ddl} style={{ width: "100%" }}>
                                            <InputLabel htmlFor="Dashboard">Dashboard</InputLabel>
                                            <Select 
                                                native
                                                label="Dashboard"
                                                size="small"
                                                value={reportId}
                                                onChange={(e) => { setReportId(parseInt(e.target.value)); }}
                                            >
                                                {
                                                    reports.map((option, key) => {
                                                        return <option key={option.RptReportId} value={option.RptReportId} label={option.Title} >{option.Title}</option>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="StartDate"
                                                label="Start Date"
                                                format="MM/dd/yyyy"
                                                size="small"
                                                value={startDate}
                                                onChange={date => setStartDate(moment(date).format("MM/DD/YYYY"))}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disableToolbar fullWidth autoOk
                                                variant="inline"
                                                inputVariant="outlined"
                                                id="EndDate"
                                                label="End Date"
                                                format="MM/dd/yyyy"
                                                size="small"
                                                minDate={startDate}
                                                value={endDate}
                                                onChange={date => setEndDate(moment(date).format("MM/DD/YYYY"))}
                                                InputAdornmentProps={{ position: "start" }}
                                                PopoverProps={{
                                                    anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                    transformOrigin: { horizontal: "left", vertical: "top" }
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                </Grid>
                                <TextField
                                    id="Sites"
                                    label="Sites"
                                    size="small"
                                    disabled
                                    onClick={treeViewOpen}
                                    value={selectedSite}
                                    variant="outlined"
                                    style={{ width: "100%" }}
                                />
                                <Dialog open={open} onClose={treeViewClose} classes={{ paper: classes.dialog }}>
                                    <DialogTitle>
                                        <Autocomplete
                                            id="Search"
                                            size="small"
                                            openOnFocus
                                            blurOnSelect={true}
                                            value={hirNode}
                                            options={hirNodes}
                                            getOptionLabel={(option) => option.Title || ""}
                                            onChange={(event, option) => hirNodeChanged(option)}
                                            renderInput={(params) => <TextField {...params} label="Search any Level or a Site Name" variant="outlined" />}
                                        />
                                    </DialogTitle>
                                    <DialogContent dividers>
                                        <div style={{ maxWidth: '100%' }}>
                                            <TreeView
                                                defaultCollapseIcon={<ExpandMoreIcon />}
                                                defaultExpandIcon={<ChevronRightIcon />}
                                                onNodeToggle={handleToggle}
                                                expanded={expanded}
                                            >
                                                {nodes.length !== 0 ? renderTree(nodes) : null}
                                            </TreeView>
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            className={classes.button}
                                            style={{ background: currentTheme.secondary, width: "50px", marginRight: "20px" }}
                                            type="button"
                                            onClick={updateSitesList}
                                        >
                                            OK
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </div>
                            <Divider style={{ height: "1px", backgroundColor: currentTheme.secondary, marginTop: "5px", marginBottom: "10px" }} />
                            <ConfirmDialog open={confirmOpen} close={confirmClose} onConfirm={selectNode} title="" message="Selected nodes in earlier level will be deselected" />
                            <iframe id="iFrameExago" title="dashboard" src="resource/exago/exagoReport.html" height="600px" width="100%" />
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
